import { formatImgUrl } from "@/utils/crop";
import { pxtorem } from "@/utils/pxtorem";
// import { formatTimeAgo } from "@/utils/time";
import { requestFollowProduct } from "@/api/product";
import useNavigation from "@/utils/useNavigate";
import { ProductModel } from "@akc/biz-api";
import { Image, Toast } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useActivate } from "react-activation";
import styles from "./index.module.less";



export interface MaterialCardProps {
  product: ProductModel;

  // 图片尺寸信息
  coverInfo: any;
  goDetail: (item: ProductModel) => void;
  setLike: (item: ProductModel,oldIsFollow: boolean) => void;
}
const videoIcon =
  "https://akim-oss.aikucun.com/e31dfec97b5c8a5ec8cf97faf0f267f6c6e0e57f_1700124380032_87.png";
const likeIcon =
  "https://akim-oss.aikucun.com/8545980b4af189ab1f4be10e3b100a319cedaf99_1700125228030_27.png";
const unLikeIcon =
  "https://akim-oss.aikucun.com/b46c103bc931434344b044e0105193ca79ee1dbd_1700125278816_8.png";
const labelIcon =
  "https://akim-oss.aikucun.com/38a80481bf2c1772fab0d1f35fd7f815a6685387_1702458140350_39.png";

  // 素材商品卡片
const MaterialProductCard: React.FC<MaterialCardProps> = props => {
  const {
    product,
    coverInfo,
    goDetail,
    setLike,
  } = props;

  const [isFollow,setIsFollow] = useState<boolean>(product?.skuExtendInfoVO?.isFollow || false);
  const [followNum,setFollowNum] = useState<number>(Number(product?.skuExtendInfoVO?.followNum) || 0);
  const {navigate2ProductVideoStream } = useNavigation();

  const onClickCard=(e) => {
    e.stopPropagation();
    // 跳商品视频大卡
    navigate2ProductVideoStream({
      activityId: "",
      activitySpuId: product?.activitySpuId ?? "",
      vcScene: "gyg_discover_page",
      materialNo: product?.materialRelationProductInfoVO?.materialNo ?? "",
      showVideoBtmGuide: "0",
      showVideoBottomBar: "0",
      hideForwardBtn: "0",
      theme: "dark",
    });
    goDetail(product);
  };

  const onLikeClick= async (e) => {
    e.stopPropagation();
    try {
      // 调用收藏/取消收藏接口
      const result = await requestFollowProduct(!isFollow, product?.spuId || "");
      setIsFollow(!isFollow);
      // 通知素材视频大卡更新点赞状态
      localStorage.setItem(
        "notifyFollowProduct",
        JSON.stringify({
          isFollow: !isFollow,
          spuId: product?.spuId,
        }),
      );
      setFollowNum(followNum + (isFollow ? -1 : 1));
      Toast.show(!isFollow ? "收藏成功" : "已取消收藏");
    } catch (error) {
      Toast.show("操作失败，请稍后再试");
      console.error("收藏操作失败:", error);
    }
    setLike(product, isFollow);
  };

  useEffect(() => {
    const newIsFollow = product?.skuExtendInfoVO?.isFollow || false;
    if(newIsFollow !== isFollow){
      setIsFollow(newIsFollow);
    }
    const newFollowNum = Number(product?.skuExtendInfoVO?.followNum) || 0;
    if(newFollowNum !== followNum){
      setFollowNum(newFollowNum);
    }
  }, [product]);

  // const timeFormat = formatTimeAgo(createTimeStamp, sysTime);
  const coverWidth = 172;
  const coverHeight = (coverInfo?.height / coverInfo?.width) * 172;
  const containVideo=product?.productVideoCardVO?.type ===  "VIDEO";
  const mainPicUrl = containVideo ? product?.productVideoCardVO?.videoCover : product?.productVideoCardVO?.imgUrls?.[0];

  if (!coverHeight) {
    console.warn(
      `图片${mainPicUrl}解析异常，可能是域名不对，会导致页面闪跳一下,对应商品是`,
      product,
    );
  }
  // 根据视频大卡页面收藏状态更新
  useActivate(() => {
    try {
      const prdVideoCardFellowChangeStr = sessionStorage.getItem("PRD_VIDEO_CARD_FELLOW_CHANGE");
      if(prdVideoCardFellowChangeStr){
        const prdVideoCardFellowChange = JSON.parse(prdVideoCardFellowChangeStr);
        const {activitySpuId,newFollowInfo}=prdVideoCardFellowChange || {};
        if(!activitySpuId || activitySpuId!==product?.activitySpuId){
          return;
        }
        const {newIsFollow,}=newFollowInfo || {};
        if(newIsFollow===isFollow){
          return;
        }
        setIsFollow(newIsFollow);
        setFollowNum(newIsFollow ? followNum + 1 : followNum - 1);
        sessionStorage.removeItem("PRD_VIDEO_CARD_FELLOW_CHANGE");
      }
    } catch (error) {
      console.error("useActivate--->error:", error);
    }
  });

  return (
    <div
      className={styles.material_card}
      onClick={onClickCard}>
      {/* 视频标识 */}
      {containVideo && <img className={styles.video_icon} src={videoIcon} />}
      {/* 主图 */}
      <Image
        src={formatImgUrl(mainPicUrl, coverWidth, coverHeight)}
        lazy={true}
        width={pxtorem(coverWidth)}
        height={coverHeight ? pxtorem(coverHeight) : undefined}
        className={styles.material_pic}
      />

      {/* 素材推荐理由/商品名称 */}
      <div className={styles.content}>
        <span style={{ textIndent: 0 }} className={styles.title}>
          {product.materialRelationProductInfoVO?.recommendReason || product?.materialRelationProductInfoVO?.title || product?.productTitle}
        </span>
      </div>

      {/* 作者/发布时间/点赞 */}
      <div className={styles.sub_content}>
        {/* <div className={styles.authpic_wrapper} >
          <img src={creatorAvatar} className={styles.author_pic} />
        </div>
        <div className={styles.author}>{timeFormat}</div> */}
        <div
          className={styles.like_wrapper}
          onClick={onLikeClick}>
          <img src={isFollow ? likeIcon : unLikeIcon} className={styles.like_pic} />
          <span className={styles.like_num}>{followNum}</span>
        </div>
      </div>
    </div>
  );
};
export default MaterialProductCard;
